"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompositeChartSettingsJSONModel = void 0;
class CompositeChartSettingsJSONModel {
    constructor(serializedState) {
        this.reset = () => {
            this.resetAsPercents();
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                // noinspection PointlessBooleanExpressionJS
                this.asPercents = serializedState.asPercents === true;
            }
        };
        this.serialize = () => {
            return {
                asPercents: this.asPercents
            };
        };
        ////////////////////////////////////////////////
        // As Percents
        ////////////////////////////////////////////////
        this.isAsPercents = () => this.asPercents;
        this.setAsPercents = (value) => {
            // noinspection PointlessBooleanExpressionJS
            this.asPercents = value === true;
        };
        this.resetAsPercents = () => this.asPercents = false;
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.CompositeChartSettingsJSONModel = CompositeChartSettingsJSONModel;
